'use client'

import '@/lib/pwa/captureInstallPrompt'
import { useEffect } from 'react'
import { PwaInstallProvider } from '@/components/common/PwaInstallPrompt'
import { isPwaEnabled, registerPwaServiceWorker } from '@/lib/pwa/registerServiceWorker'

type PwaProviderProps = {
  isDesktop: boolean
  children?: React.ReactNode
}

export default function PwaProvider({ isDesktop, children }: PwaProviderProps) {
  useEffect(() => {
    if (!isPwaEnabled()) {
      return
    }

    registerPwaServiceWorker()
  }, [])

  if (!isPwaEnabled()) {
    return children ?? null
  }

  return (
    <PwaInstallProvider showBanner={!isDesktop}>
      {children}
    </PwaInstallProvider>
  )
}
